import styled from 'styled-components';

export const Container = styled.div`
  padding: 0 1rem;
  margin-bottom: 1rem;
`;

export const TruckIcon = styled.img`
  cursor: pointer;
`;

export const TableHeaderContent = styled.div`
  background: ${({ theme }) => theme.colors.white};
  display: flex;
  width: 100%;
  justify-content: space-between;
  flex-direction: column;
  padding: 1rem;
  @media (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
    flex-direction: row;
  }
`;

export const ButtonContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  border-radius: 0.55rem;
`;

export const SelectionContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 1rem;
  width: 50%;
  margin-right: 0.5rem;
  margin-bottom: 1rem;
  & > span {
    font-size: 1rem;
  }
  @media (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
    margin-bottom: 0;
  }
`;

export const OrdersTableContainer = styled.div`
  display: grid;
  padding: 0 1.5rem 1rem 1.5rem;

  gap: 1rem;
`;

export const TableContainer = styled.div`
  max-width: 100%;
  overflow-x: auto;
  & .truck-btn-cancel-order {
    justify-content: center;
    display: flex;
  }
  & .truck-btn-cancel-order > .hefesto-button {
    padding: 0;
  }
`;

export const TableHeaderColumnContainer = styled.div<{ width?: number }>`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  ${({ width }) => width && `min-width: ${width}px`}
`;

export const TableHeaderColumnItems = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const TableHeaderInput = styled.div`
  position: relative;
  display: flex;
  align-items: center;
`;

export const TableOrderNumberSelectable = styled.span`
  color: ${({ theme }) => theme.colors.blue6};
  font-weight: 700;
  text-decoration: underline;
  cursor: pointer;
`;

export const TableOrderEmitterDescription = styled.span`
  color: ${({ theme }) => theme.colors.grayDark4};
  font-weight: 600;
  font-family: Work Sans;
  font-size: 16px;
`;

export const TableCell = styled.span`
  font-size: 1rem;
  font-weight: 400;
  line-height: 24px;
`;

export const TableHeaderContainer = styled.div`
  padding: 0.5rem;
  display: flex;
  justify-content: space-between;

  background: ${({ theme }) => theme.colors.white};
  border-radius: 4px;
  flex-wrap: wrap;
  gap: 1rem;
`;

export const TableHeaderContainerButtons = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: flex-end;
  gap: 1rem;
  width: 100%;

  .hefesto-button {
    height: 48px;
  }

  & > :first-child {
    flex: 1 1 160px;
    max-width: 337px;
  }

  & > :nth-child(2) {
    flex: 1 1 160px;
    max-width: 290px;
  }

  & > :nth-child(3) {
    flex: 0 0 185px;
    width: 185px;
  }

  & > :nth-child(4) {
    flex: 0 0 auto;
  }

  @media (max-width: ${({ theme }) => theme.breakpoints.tablet}) {
    flex-direction: column;
    align-items: stretch;

    & > :first-child,
    & > :nth-child(2),
    & > :nth-child(3) {
      flex: 1 1 100%;
      max-width: none;
      width: 100%;
    }
  }
`;

export const TableHeaderRightActions = styled.div`
  display: flex;
  gap: 0.5rem;
  align-items: flex-end;

  & > button[name='personalize-table'] {
    width: 172px;
    min-width: 172px;
    flex: 0 0 auto;
    padding: 0;
  }

  & > button[name='download-xls'] {
    width: 48px;
    min-width: 48px;
    flex: 0 0 auto;
    padding: 0;
  }
`;

export const TableHeaderActionButton = styled.div`
  display: flex;
  align-items: flex-end;

  > button {
    padding-inline: 0;
    width: 48px;
    min-width: 48px;
    flex: 0 0 auto;
  }

  .hefesto-button__label {
    display: flex;
    justify-content: center;
    align-items: center;
  }
`;

export const MessageWithoutEmitter = styled.h4`
  color: #495961;
  font-size: 24px;
  line-height: 32px;
  font-family: 'Source Sans Pro';
  font-weight: 600;
  text-align: center;
  width: 31rem;
`;
